import React from 'react';
import { Modal } from 'antd'; 

function printPartOfPage (elementId, uniqueIframeId) {
    const content = document.getElementById(elementId)
    let pri
    if (document.getElementById(uniqueIframeId)) {
        pri = document.getElementById(uniqueIframeId).contentWindow
    } else {
        const iframe = document.createElement('iframe')
        iframe.setAttribute('title', uniqueIframeId)
        iframe.setAttribute('id', uniqueIframeId)
        iframe.setAttribute('style', 'height: 0px; width: 0px; position: absolute;')
        document.body.appendChild(iframe)
        pri = iframe.contentWindow
    }
    pri.document.open()
    pri.document.write(content.innerHTML)
    pri.document.close()
    pri.focus()
    pri.print()
}


const InventoryTransactionTicket = props => {
    const rightNow = new Date().toLocaleString();

    return (
        <Modal
            id="invoice"
            title="Transacción de inventario"
            cancelText="CERRAR"
            okText="IMPRIMIR"
            onOk={() => {
                printPartOfPage("test", "testInvoice");
            }}
            onCancel={props.onCancel}
            visible={props.visible}
            centered={true}
            width={800}
        >
            <div id="test">
                <p><strong>{props.hotel}</strong></p>
                <p>{props.transactionTitle}</p>
                <p><strong>Fecha: </strong> {rightNow}</p>
                <p><strong>Inventario: </strong> {props.inventory}</p>
                <p><strong>Usuario: </strong>{props.user}</p>
                <br />
                <p><strong></strong></p>
                <br />
                {props.transactionItems}
            </div>
        </Modal>
    );
};


export default InventoryTransactionTicket;